import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Aus = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M5 7h7a1 1 0 1 0 0-2H5a1 1 0 0 0 0 2zM5 11h14a1 1 0 1 0 0-2H5a1 1 0 0 0 0 2zM19 7a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2h2z" />
    <path d="M22.071 0H1.93A1.929 1.929 0 0 0 0 1.929V15.07C0 16.137.863 17 1.929 17H7.1a5 5 0 0 1 0-2H2V2h20v13h-5.101a5 5 0 0 1 0 2h5.172A1.929 1.929 0 0 0 24 15.071V1.93A1.929 1.929 0 0 0 22.071 0z" />
    <path d="M12 12c-2.206 0-4 1.794-4 4 0 1.005.385 1.914 1 2.618V24l3-1 3 1v-5.382c.615-.704 1-1.613 1-2.618 0-2.206-1.794-4-4-4zm1 8v1.225l-.368-.122a2 2 0 0 0-1.264 0l-.368.122v-1.367c.322.084.653.142 1 .142s.678-.058 1-.142V20zm-1-2c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" />
  </SvgIcon>
);

export default Aus;
